<template>
  <div>
    <div class="sub-header">
      <div
        class="header d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center">
          <!-- <i :class="['icon-question', 'align-self-baseline  header-icon']"></i> -->
          <h1 class="xxl">
            {{ !isQuestionPage ? resource['hrvenue.InterviewListTitle'] : resource['questionGenerator.pageTitle'] }}
          </h1>
        </div>
        <div class="d-flex align-items-center" v-if="!isQuestionPage">
          <div
            id="job-counts-wrapper"
            class="info d-sm-flex pl-3 pr-3  justify-content-center align-items-center text-center"
          >
            <div class="collar-text">
              {{ resource['hrvenue.interviewlist.right']  }}&nbsp;
            </div>
            <div class="job-count">
              {{ layout.creditCount }}
            </div>
          </div>
          <button
            v-if="!isMobile"
            class="btn with-icon bg-purple text-white ml-3 pt-2 pb-2 h-auto create-btn"
            id="createNewInterviewBtnOne"
            @click="clickCreateNew"
          >
            <i class="icon-add" />
            {{ resource['hrvenue.createInterview'] }}
        </button>
      </div>
        <div class="d-flex align-items-center" v-if="isQuestionPage && !isMobile">
          <button
            class="btn with-icon bg-purple text-white ml-3 pt-2 pb-2 h-auto create-btn"
            id="createNewInterviewBtnOne"
            @click="clickCreateNew"
          >
            {{ resource['questionGenerator.createInterview'] }}
          </button>
      </div>
      </div>

    </div>
    <div class="page-view">
      <b-container>
        <div v-if="loading">
          <vue-content-loading :height="150" :speed="1">
            <rect x="0" y="10" rx="4" ry="4" width="100%" height="40" />
            <rect x="0" y="55" rx="4" ry="4" width="100%" height="40" />
            <rect x="0" y="100" rx="4" ry="4" width="100%" height="40" />
          </vue-content-loading>
        </div>
        <div v-else>
          <div class="interview-list-filters-area" @click="closeSelect">
            <multiselect
              ref="sortMultiselect"
              v-model="sortValue"
              label="title"
              track-by="title"
              :options="sortOptions"
              :multiple="false"
              :searchable="false"
              :close-on-select="true"
              :hide-selected="false"
              :preselect-first="false"
              @select="changeFilter('sort')"
              @remove="removeFilter('sort')"
            >
              <template #placeholder>
                <span class="option__desc">
                  <span class="option__title">
                    <i class="icon-sort" />
                    <span>{{ resource['order.sortByText'] }}</span>
                  </span>
                </span>
              </template>
              <template #singleLabel="props">
                <span :class="`option__desc ${sortValue && 'selected-option'}`">
                  <span class="option__title">
                    <i class="icon-sort" />
                    <span>{{ props.option.title }}</span>
                  </span>
                </span>
              </template>
            </multiselect>
            <multiselect
              ref="statusMultiselect"
              class="status-multiselect"
              v-model="statusValue"
              label="title"
              track-by="title"
              :options="statusOptions"
              :multiple="false"
              :searchable="false"
              :close-on-select="true"
              :hide-selected="false"
              :preselect-first="false"
              @select="changeFilter('status')"
              @remove="removeFilter('status')"
            >
              <template #placeholder>
                <span class="option__desc">
                  <span class="option__title">
                    <span>{{ resource['orderStatusText'] }}</span>
                  </span>
                </span>
              </template>
              <template #singleLabel="props">
                <span :class="`option__desc ${statusValue && 'selected-option'}`">
                  <span class="option__title">
                    <span>{{ props.option.title }}</span>
                  </span>
                </span>
              </template>
            </multiselect>
            <multiselect
              v-if="!isQuestionPage"
              ref="typeMultiselect"
              class="type-multiselect"
              v-model="typeValue"
              label="title"
              track-by="title"
              :options="typeOptions"
              :multiple="false"
              :searchable="false"
              :close-on-select="true"
              :hide-selected="false"
              :preselect-first="false"
              @select="changeFilter('type')"
              @remove="removeFilter('type')"
            >
              <template #placeholder>
                <span class="option__desc">
                  <span class="option__title">
                    <span>{{ resource['orderTypeText'] }}</span>
                  </span>
                </span>
              </template>
              <template #singleLabel="props">
                <span :class="`option__desc ${typeValue && 'selected-option'}`">
                  <span class="option__title">
                    <span>{{ props.option.title }}</span>
                  </span>
                </span>
              </template>
            </multiselect>
            <div class="search-area">
              <div class="search-area__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M13.3137 12.0598H12.6553L12.422 11.8348C13.422 10.6681 13.9387 9.07643 13.6553 7.38477C13.2637 5.0681 11.3303 3.2181 8.997 2.93477C5.47201 2.50143 2.50534 5.4681 2.93867 8.9931C3.22201 11.3264 5.07201 13.2598 7.38867 13.6514C9.08034 13.9348 10.672 13.4181 11.8387 12.4181L12.0637 12.6514V13.3098L15.6053 16.8514C15.947 17.1931 16.5053 17.1931 16.847 16.8514C17.1887 16.5098 17.1887 15.9514 16.847 15.6098L13.3137 12.0598ZM8.31367 12.0598C6.23867 12.0598 4.56367 10.3848 4.56367 8.30977C4.56367 6.23477 6.23867 4.55977 8.31367 4.55977C10.3887 4.55977 12.0637 6.23477 12.0637 8.30977C12.0637 10.3848 10.3887 12.0598 8.31367 12.0598Z" fill="#333333"/>
                </svg>
              </div>
              <input
                type="text"
                id="search-candidates"
                name="search-candidates"
                class="search-area__input"
                v-model="searchText"
                @input="searchInterviews"
                :placeholder="this.pageType === 'question' ? resource['questionGeneratorSearchPlaceholder'] : resource['interviewList.SearchPlaceholder']"
              />
            </div>
          </div>
          <div v-if="isListEmpty">
            <b-row class="justify-content-center m-0">
              <b-col cols sm="12" md="12" xl="12" class="m-0 p-0 mt-4 mb-5">
                <b-col class="mb-1 text-center">
                  <span class="empty-title">
                    {{ isQuestionPage ? resource['questionGenerator.emptyPageTitle'] : resource['hrvenue.EmptyPageTitle'] }}
                  </span>
                </b-col>
              </b-col>
              <interview-empty-card
                :title="isQuestionPage ? resource['questionGenerator.emptyCardOneTitle'] : resource['hrvenue.emptyCardOneTitle']"
                :description="isQuestionPage ? resource['questionGenerator.emptyCardOneDescription'] : resource['hrvenue.emptyCardOneDescription']"
                :imgSrc="isQuestionPage ? require('@/assets/hrVenue/list.svg') : require('@/assets/hrVenue/prepare-questions.svg')"
                :cardOrder="1"
                :pageType="pageType"
              />
              <interview-empty-card
                :title="isQuestionPage ? resource['questionGenerator.emptyCardTwoTitle'] : resource['hrvenue.emptyCardTwoTitle']"
                :description="isQuestionPage ? resource['questionGenerator.emptyCardTwoDescription'] : resource['hrvenue.emptyCardTwoDescription']"
                :imgSrc="isQuestionPage ? require('@/assets/hrVenue/pencil.svg') : require('@/assets/hrVenue/candidates-reply.svg')"
                :cardOrder="2"
                :pageType="pageType"
              />
              <interview-empty-card
                :title="isQuestionPage ? resource['questionGenerator.emptyCardThreeTitle'] : resource['hrvenue.emptyCardThreeTitle']"
                :description="isQuestionPage ? resource['questionGenerator.emptyCardThreeDescription'] : resource['hrvenue.emptyCardThreeDescription']"
                :imgSrc="isQuestionPage ? require('@/assets/hrVenue/candidates.svg') : require('@/assets/hrVenue/watch-replies.svg')"
                :cardOrder="3"
                :pageType="pageType"
              />
            </b-row>
          </div>
          <div v-else>
            <div>
              <div class="interview-list">
                <!-- Header Bölümü -->
                <header class="interview-list__header">
                  <div class="interview-list__column interview-list__column--title cursor-pointer" :class="orderTitle" @click="orderInterviews('orderTitle', 1)">
                    <h4 v-if="!isQuestionPage">{{ resource['interviewListHeaderTitleText']}}</h4>
                    <h4 v-else>{{ resource['questionListHeaderTitleText']}}</h4>
                  </div>
                  <div class="interview-list__column interview-list__column--counts" v-if="!isQuestionPage" ref="countsColumn">
                    <h4 class="interview-list__count-title cursor-pointer" :class="orderCandidates" @click="orderInterviews('orderCandidates', 4)">{{ resource['interviewListHeaderCandidatesText']}}</h4>
                    <h4 class="interview-list__count-title cursor-pointer" :class="orderCompleted" @click="orderInterviews('orderCompleted', 5)">{{ resource['interviewListHeaderCompletedTitleText']}}</h4>
                    <h4 class="interview-list__count-title cursor-pointer" :class="orderIncomplete" @click="orderInterviews('orderIncomplete', 6)">{{ resource['interviewListHeaderIncompleteTitleText']}}</h4>
                  </div>
                  <div class="interview-list__column interview-list__column--status">
                    <h4>{{ resource['interviewListHeaderStatusText']}}</h4>
                  </div>
                  <div class="interview-list__column interview-list__column--analyze cursor-pointer" :class="orderCreation" @click="orderInterviews('orderCreation', 3)" v-if="isQuestionPage">
                    <h4>{{ resource['questionListHeaderCreationDateText']}}</h4>
                  </div>
                  <div class="interview-list__column interview-list__column--analyze cursor-pointer" :class="orderUpdate" @click="orderInterviews('orderUpdate', 2)" v-if="isQuestionPage">
                    <h4>{{ resource['questionListHeaderLastUpdateText']}}</h4>
                  </div>
                  <div class="interview-list__column interview-list__column--analyze" v-if="!isQuestionPage">
                    <h4>{{ resource['interviewListHeaderAnalyzeText']}}</h4>
                  </div>
                </header>

                <section class="interview-list__body">
                  <interview-list-card-item
                    v-for="(item, index) in interviewList"
                    :key="index"
                    :item="item"
                    :pageType="pageType"
                    :countsColumnWidth="$refs.countsColumn ? $refs.countsColumn.offsetWidth : null"
                    @updateStatus="updateStatus"
                    @copyInterview="copyInterview"
                    @getInterviews="getAll"
                    :sendReportRight="checkRemainingRight(7)"
                    :analyzeRight="checkRemainingRight(4)"
                    :rights="rights"
                    :isLastItem="index === interviewList.length - 1"
                  />
                </section>
              </div>
              <step-pagination
                v-show="isShowPagination || this.paginationCount.total > 0"
                :step-total="paginationCount.total"
                :step-data-count="paginationCount.currentItemSize"
                :current-page-index="paginationCount.currentPageIndex"
                @currentIndex="getJobListWithChangedPaginationIndex"
              />
            </div>
          </div>
        </div>
      </b-container>
    </div>
    <div v-if="isMobile" class="mobile-actions-area">
          <button
              v-if="!isQuestionPage"
              class="btn with-icon bg-purple text-white ml-3 pt-2 pb-2 h-auto create-btn"
              id="createNewInterviewBtnOne"
              @click="clickCreateNew"
            >
              <i class="icon-add" />
              {{ resource['hrvenue.createInterview'] }}
          </button>
          <button
            v-else
            class="btn with-icon bg-purple text-white pt-2 pb-2 h-auto"
            id="createNewInterviewBtnOne"
            @click="clickCreateNew"
          >
            {{ resource['questionGenerator.createInterview'] }}
          </button>
    </div>
    <b-modal v-model="layout.updateStatusConfirm" id="modal-center" centered hide-footer modal-class="new-modal">
      <div slot="modal-header" class="d-flex justify-content-end w-100">
        <i class="icon-close custom-modal-close cursor-pointer" @click="layout.updateStatusConfirm = false" />
      </div>
      <div class="d-flex align-items-center justify-content-center flex-column w-100">
        <img src="/images/upgrade.svg" loading="lazy" alt="upgrade">
        <h2>{{ isQuestionPage ? resource['hrvenue.questionList.updateStatus'] : resource['hrvenue.interviewList.updateStatus'] }}</h2>
        <p>{{ isQuestionPage ? resource['hrvenue.questionList.updateStatusContentInfo'] : resource['hrvenue.interviewList.updateStatusContentInfo'] }}</p>
        <div class="w-100 d-flex justify-content-between gap-3">
          <b-button
            name="cancel"
            class="border-button-create"
            @click="modalCancelButton"
          >
            <span>{{ resource['hrvenue.interviewList.updateCancel'] }}</span>
          </b-button>
          <b-button
            name="updateStatusConfirm"
            class="bg-button gap-2 d-flex align-items-center"
            @click="updateStatusConfirm"
          >
            <span>{{ layout.updateStatusConfirmText }}</span>
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import { showNotification } from '@/static/helpers';
import HrVenueService from '@/services/hrvenue.service';
import signalRService from '../../composables/signalrService';

export default {
  name: 'InterviewList',

  components: {
    InterviewEmptyCard: () => import('./interviewList/interviewEmptyCard.vue'),
    StepPagination: () => import('../layout/StepPagination.vue'),
    InterviewListCardItem: () => import('./interviewList/interviewListCardItem.vue'),
    Multiselect,
  },

  data() {
    return {
      loading: true,
      tabIndex: 0,
      interviewList: [],
      layout: {
        hasHrVenue: true,
        creditCount: '',
        updateStatusConfirm: false,
        updateStatusConfirmText: '',
        updateStatusConfirmSelectedInterviewId: 0,
        updateStatusConfirmSelectedInterviewStatus: false,

        openPopup: false,
        popupTitle: '',
        popupDescription: '',
        popupType: -1,
        popupCloseButtonText: '',
        popupCloseButtonClass: '',
      },
      paginationCount: {
        currentItemSize: 20,
        currentPageIndex: 1,
        total: 0,
        totalIndex: 0,
      },
      pageType: '',
      searchText: '',
      searchTextTimeout: null,
      rights: [],
      isMobile: false,

      orderTitle: 'default',
      orderCandidates: 'default',
      orderCompleted: 'default',
      orderIncomplete: 'default',
      orderCreation: 'default',
      orderUpdate: 'default',

      sortValue: null,
      sortOptions: [],
      statusValue: null,
      statusOptions: [],
      typeValue: null,
      typeOptions: [],

      selectedOrder: 0,
      selectedSort: 0,
      selectedStatus: null,
      selectedType: [1, 3],
    };
  },

  computed: {
    ...mapGetters([]),

    isListEmpty() {
      return this.interviewList.length === 0;
    },

    isShowPagination() {
      return !this.isListEmpty && !this.loading;
    },

    isShowCredit() {
      return this.layout.creditCount > -1;
    },
    isQuestionPage() {
      return this.pageType === 'question';
    },
  },

  async created() {
    this.pageType = this.$route.path.includes('/question-generator') ? 'question' : 'interview';
    this.getCreditRight();
    await this.getAll();
    this.loading = false;
    if (this.$route.query && this.$route.query.s === 'true') {
      showNotification(this.resource['Label.Success'], this.resource['pricing.successMessage'], 'success');
    }
    this.rights = await this.getRights();

    this.sortOptions = [
      { id: 1, title: this.resource.orderLastUpdatesText },
      { id: 2, title: this.resource.orderCreationDateText },
    ];

    this.statusOptions = [
      { id: 1, title: this.resource.orderAllText },
      { id: 2, title: this.resource.publishedText },
      { id: 3, title: this.resource.passiveText },
    ];

    this.typeOptions = [
      { id: 1, title: this.resource.orderAllText },
      { id: 2, title: this.resource.orderVideoText },
      { id: 3, title: this.resource.orderInPersonText },
    ];
  },

  mounted() {
    document.addEventListener('click', this.closeSelect);
    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    signalRService.addEventListener('RefreshInterviewList', async () => {
      await this.getAll();
    });
  },

  methods: {
    ...mapActions([]),

    changeFilter(type) {
      if (type === 'status') {
        if (this.statusValue?.id === 1) {
          this.selectedStatus = null;
        } else if (this.statusValue?.id === 2) {
          this.selectedStatus = true;
        } else if (this.statusValue?.id === 3) {
          this.selectedStatus = false;
        } else {
          this.selectedStatus = null;
        }
      } else if (type === 'sort') {
        this.orderTitle = 'default';
        this.orderCandidates = 'default';
        this.orderCompleted = 'default';
        this.orderIncomplete = 'default';
        this.orderCreation = 'default';
        this.orderUpdate = 'default';
        if (this.sortValue?.id === 1) {
          this.selectedSort = 4;
          this.selectedOrder = 2;
        } else if (this.sortValue?.id === 2) {
          this.selectedSort = 3;
          this.selectedOrder = 2;
        } else {
          this.selectedSort = 0;
          this.selectedOrder = 0;
        }
      } else if (type === 'type') {
        if (this.typeValue?.id === 1) {
          this.selectedType = [1, 3];
        } else if (this.typeValue?.id === 2) {
          this.selectedType = [1];
        } else if (this.typeValue?.id === 3) {
          this.selectedType = [3];
        } else {
          this.selectedType = [1, 3];
        }
      }
      this.getAll();
    },

    removeFilter(type) {
      if (type === 'sort') {
        this.selectedSort = 0;
      } else if (type === 'status') {
        this.selectedStatus = null;
      } else if (type === 'type') {
        this.selectedType = [1, 3];
      }
      this.getAll();
    },

    orderInterviews(type, enumType) {
      this.sortValue = null;

      // set class names for icon
      const orderTypes = {
        orderTitle: ['orderCandidates', 'orderCompleted', 'orderIncomplete', 'orderCreation', 'orderUpdate'],
        orderCandidates: ['orderTitle', 'orderCompleted', 'orderIncomplete', 'orderCreation', 'orderUpdate'],
        orderCompleted: ['orderTitle', 'orderCandidates', 'orderIncomplete', 'orderCreation', 'orderUpdate'],
        orderIncomplete: ['orderTitle', 'orderCandidates', 'orderCompleted', 'orderCreation', 'orderUpdate'],
        orderCreation: ['orderTitle', 'orderCandidates', 'orderCompleted', 'orderIncomplete', 'orderUpdate'],
        orderUpdate: ['orderTitle', 'orderCandidates', 'orderCompleted', 'orderIncomplete', 'orderCreation'],
      };
      const currentState = this[type];
      // eslint-disable-next-line no-nested-ternary
      const newState = (currentState === 'default' ? 'desc' : (currentState === 'desc' ? 'asc' : 'default'));
      this[type] = newState;
      orderTypes[type].forEach((orderType) => {
        this[orderType] = 'default';
      });

      // set selectedSort and selectedOrder for API
      this.selectedSort = enumType;
      // eslint-disable-next-line no-nested-ternary
      this.selectedOrder = (newState === 'default' ? 0 : (newState === 'asc' ? 1 : 2));
      if (this.selectedOrder === 0) {
        this.selectedSort = 0;
      }
      this.getAll();
    },
    closeSelect(event) {
      const refs = ['sortMultiselect', 'statusMultiselect', 'typeMultiselect'];
      refs.forEach((ref) => {
        if (this.$refs[ref] && !this.$refs[ref].$el.contains(event.target)) {
          this.$refs[ref].deactivate();
        }
      });
    },

    handleResize() {
      this.isMobile = window.innerWidth <= 1048;
    },

    async getRights() {
      const response = await HrVenueService.getRights([3, 4, 7]);
      return response;
    },

    checkRemainingRight(type) {
      const right = this.rights?.find((item) => item.companyRightType === type);
      return right?.totalRemainingRight > 0;
    },

    clickCreateNew() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      if (this.isQuestionPage) {
        this.$router.push({
          name: 'QuestionGeneratorAddView',
          params: {
            lang,
          },
        });
        dataLayer.push({
          event: 'ga4_event',
          event_name: 'question_generator_click',
          page_type: 'question-list-create',
          site_type: 'interview',
        });
      } else {
        this.$router.push({
          name: 'InterviewAddView',
          params: {
            lang,
          },
        });

        dataLayer.push({
          event: 'ga4_event',
          event_name: 'create_interview_click',
          page_type: 'interview-listing',
          site_type: 'interview',
        });
      }
    },

    modalCancelButton() {
      this.layout.updateStatusConfirm = false;
      // make passive popup cancel button click
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'make_interview_passive_cancel',
        page_type: 'interview-listing',
        site_type: 'interview',
      });
    },

    async updateStatusConfirm() {
      try {
        this.layout.updateStatusConfirm = false;

        const { updated } = await HrVenueService.updateInterviewStatus(
          this.layout.updateStatusConfirmSelectedInterviewId,
          this.layout.updateStatusConfirmSelectedInterviewStatus,
        );
        if (updated) {
          let content = this.resource['hrvenue.interviewlist.successMessage'];
          if (!this.layout.updateStatusConfirmSelectedInterviewStatus) {
            dataLayer.push({
              event: 'ga4_event',
              event_name: 'button_click',
              event_parameters: {
                button_name: 'make-passive',
              },
              page_type: 'interview-listing',
              site_type: 'interview',
            });
            content = this.resource['hrvenue.interviewlist.successMessagePassive'];
          } else {
            dataLayer.push({
              event: 'ga4_event',
              event_name: 'button_click',
              event_parameters: {
                button_name: 'make-active',
              },
              page_type: 'interview-listing',
              site_type: 'interview',
            });
          }
          showNotification(this.resource['Label.Success'], content, 'success');
          await this.getAll();
          if (!this.layout.updateStatusConfirmSelectedInterviewStatus) {
            dataLayer.push({
              event: 'ga4_event',
              event_name: 'make_interview_passive_approve',
              page_type: 'interview-listing',
              site_type: 'interview',
            });
          }
        } else {
          showNotification(
            this.resource['label.Warning'],
            this.resource['interviewList.TransactionFailedError'],
            'warning',
            10000,
          );
        }
      } catch (e) {
        showNotification(
          this.resource['label.Warning'],
          e?.data?.result?.errors?.[0]?.errorMessage,
          'warning',
          10000,
        );
      } finally {
        this.loading = false;
      }
    },
    async updateStatus(interview, status) {
      this.layout.updateStatusConfirmSelectedInterviewId = interview.id;
      this.layout.updateStatusConfirmSelectedInterviewStatus = status;
      if (!status) {
        this.layout.updateStatusConfirmText = this.resource['hrvenue.interviewlist.passive'];
        this.layout.updateStatusConfirm = true;
      } else {
        this.layout.updateStatusConfirmText = this.resource['hrvenue.interviewlist.active'];
        this.updateStatusConfirm();
      }
    },
    async copyInterview(interviewId) {
      const {
        visibilityType,
        authorizedUsers,
        languageId,
        questionLanguageId,
        interview: {
          id,
          name,
          description,
          expireDate,
          interviewQuestions,
          type,
          positionId,
          jobDescription,
        },
      } = await HrVenueService.getInterview(interviewId);

      if (!id) {
        showNotification(
          this.resource['label.error'],
          this.resource['hrvenue.interviewlist.copy.interviewNotFoundMessage'],
          'error',
        );
      } else {
        const newQuestions = interviewQuestions;
        newQuestions.forEach((item) => {
          item.id = null;
          item.interviewId = null;
        });
        const modifiedAuthorizedUsers = authorizedUsers?.map(({ id }) => id);
        const response = await HrVenueService.createInterview(
          name,
          description,
          expireDate,
          newQuestions,
          this.isQuestionPage ? 2 : type,
          visibilityType,
          modifiedAuthorizedUsers,
          positionId,
          languageId,
          questionLanguageId,
          jobDescription,
        );
        if (response.created) {
          showNotification(
            this.resource['Label.Success'],
            this.resource['hrvenue.interviewlist.copy.successMessage'],
            'success',
          );

          dataLayer.push({
            event: 'ga4_event',
            event_name: 'button_click',
            event_parameters: {
              button_name: 'copy',
            },
            page_type: 'interview-listing',
            site_type: 'interview',
          });

          await this.getAll();
        } else {
          showNotification(
            this.resource['label.error'],
            this.resource['hrvenue.interviewlist.copy.failMessage'],
            'error',
          );
        }
      }
    },

    async getJobListWithChangedPaginationIndex(newIndex) {
      if (this.paginationCount.currentPageIndex === newIndex) {
        return;
      }
      this.loading = true;
      this.paginationCount.currentPageIndex = newIndex;
      await this.getAll();
      this.loading = false;
    },

    async getCreditRight() {
      if (this.layout.hasHrVenue) {
        const { totalUsableRight } = await HrVenueService.getCreditRight();
        this.layout.creditCount = totalUsableRight >= 0 ? totalUsableRight : 0;
      }
    },

    async getAll() {
      // HrVenueService.healthCheck();
      if (this.layout.hasHrVenue) {
        const {
          totalCount, items,
        } = await HrVenueService.getInterviews(
          this.selectedStatus,
          this.paginationCount.currentPageIndex,
          this.paginationCount.currentItemSize,
          this.isQuestionPage ? [2] : this.selectedType,
          this.searchText,
          true,
          this.selectedSort,
          this.selectedOrder,
        );
        if (items) {
          this.paginationCount.total = +totalCount;
          this.paginationCount.totalIndex = Math.floor(
            totalCount / items.length,
          );
          this.interviewList = items;
        } else {
          this.interviewList = [];
        }
      }
    },

    async searchInterviews() {
      this.paginationCount.currentPageIndex = 1;
      clearTimeout(this.searchTextTimeout);
      this.searchTextTimeout = setTimeout(async() => {
        if (this.searchText === '') {
          await this.getAll();
        } else if (this.searchText.length > 1) {
          await this.getAll();
        }
      }, 700);
    },
  },

  /* eslint-disable no-dupe-keys */
  beforeDestroy() {
    document.removeEventListener('click', this.closeSelect);
    window.removeEventListener('resize', this.handleResize);
    signalRService.removeEventListener('RefreshInterviewList');
  },
};
</script>

<style lang="scss" scoped>
@import '~@/style/starter.scss';

#job-counts-wrapper {
  .collar-text,
  .job-count {
    min-width: 24px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #595959;
    @include media-breakpoint-down(sm) {
      font-size: 11px;
      line-height: 16px;
    }
  }
}

::v-deep .interview-list {
  min-height: 60vh;
  width: 100%;

  @include media-breakpoint-down(md) {
    min-height: auto;
  }

  // Header (Liste Başlığı)
  &__header {
    display: flex;
    width: 100%;
    padding: var(--Padding-Small, 4px) var(--Padding-Medium, 12px) var(--Padding-Small, 4px) var(--Padding-Large, 16px);
    align-items: flex-end;
    gap: var(--Padding-4XLarge, 48px);
    border-radius: 8px 8px 0 0;
    border: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #E5E5E5);
    background: var(--Background-Colors-Primary-Gray, #EEE);

    @media only screen and (max-width: 1150px) {
      display: none;
    }

    h4 {
      color: var(--Text-Colors-Primary-Gray-Text, #333);
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }
  }

  // Liste Gövdesi
  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #E5E5E5;
    border-top: 0;
    border-radius: 0 0 8px 8px;
    margin-bottom: 32px;

    @media only screen and (max-width: 1150px) {
      .interview-list__column {
        width: 100% !important;
      }
      .interview-list__column--counts .interview-list__count {
        justify-content: flex-start;
      }
    }
  }

  // Sütunlar (Columns)
  &__column {
    &--title {
      display: flex;
      align-items: center;
      gap: var(--Padding-XSmall, 2px);
      flex-shrink: 0;
      width: 240px;
      position: relative;

      p {
        overflow-wrap: anywhere;
      }

      &.asc {
        h4 {
          &::after {
            top: 2px;
            position: absolute;
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7.23876 5.79898V10.2581C7.23876 10.6661 6.90489 11 6.49682 11C6.08875 11 5.75488 10.6661 5.75488 10.2581V5.79898H4.4268C4.09292 5.79898 3.9297 5.39833 4.16712 5.16833L6.23714 3.10573C6.38553 2.96476 6.61553 2.96476 6.76392 3.10573L8.83394 5.16833C9.07136 5.39833 8.90071 5.79898 8.57426 5.79898H7.23876Z" fill="%23333333"/></svg>');
          }
        }
      }
      &.desc {
        h4 {
          &::after {
            top: 2px;
            position: absolute;
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7.23876 8.20102V3.74194C7.23876 3.33387 6.90489 3 6.49682 3C6.08875 3 5.75488 3.33387 5.75488 3.74194V8.20102H4.4268C4.09292 8.20102 3.9297 8.60167 4.16712 8.83167L6.23714 10.8943C6.38553 11.0352 6.61553 11.0352 6.76392 10.8943L8.83394 8.83167C9.07136 8.60167 8.90071 8.20102 8.57426 8.20102H7.23876Z" fill="%23333333"/></svg>');
          }
        }
      }

      &:hover {
        &.default {
          h4 {
            &::after {
              top: 2px;
              position: absolute;
              content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M5.04402 1.95617L3.41652 3.58367C3.22985 3.76451 3.35819 4.0795 3.62069 4.0795H4.66485V7.58534C4.66485 7.90617 4.92735 8.16867 5.24819 8.16867C5.56902 8.16867 5.83152 7.90617 5.83152 7.58534V4.0795H6.87569C7.13819 4.0795 7.26652 3.76451 7.07985 3.58367L5.45235 1.95617C5.34152 1.84534 5.15485 1.84534 5.04402 1.95617ZM9.33152 9.92451V6.41867C9.33152 6.09784 9.06902 5.83534 8.74819 5.83534C8.42735 5.83534 8.16485 6.09784 8.16485 6.41867V9.92451H7.12069C6.85819 9.92451 6.72985 10.2395 6.91652 10.4203L8.54402 12.042C8.66069 12.1528 8.84152 12.1528 8.95819 12.042L10.5857 10.4203C10.7724 10.2395 10.6382 9.92451 10.3815 9.92451H9.33152Z" fill="%23333333"/></svg>');
            }
          }
        }
      }
    }

    &--counts {
      display: flex;
      align-items: center;
      gap: var(--Padding-XLarge, 24px);

      @media only screen and (max-width: 1150px) {
        flex-direction: column;
        align-items: flex-start;
        padding: 0;
        gap: 8px;
      }
    }

    &--status {
      display: flex;
      width: 86px;
      padding: 0;
      align-items: center;
      gap: var(--Padding-XSmall, 2px);
      flex-shrink: 0;

      p {
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Roboto;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
      }

      i {
        font-size: 14px;
      }
    }

    &--analyze {
      display: flex;
      min-width: 98px;
      padding: 0;
      align-items: center;
      gap: var(--Padding-XSmall, 2px);
      flex-shrink: 0;
      position: relative;

      &.asc {
        h4 {
          &::after {
            top: 2px;
            position: absolute;
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7.23876 5.79898V10.2581C7.23876 10.6661 6.90489 11 6.49682 11C6.08875 11 5.75488 10.6661 5.75488 10.2581V5.79898H4.4268C4.09292 5.79898 3.9297 5.39833 4.16712 5.16833L6.23714 3.10573C6.38553 2.96476 6.61553 2.96476 6.76392 3.10573L8.83394 5.16833C9.07136 5.39833 8.90071 5.79898 8.57426 5.79898H7.23876Z" fill="%23333333"/></svg>');
          }
        }
      }
      &.desc {
        h4 {
          &::after {
            top: 2px;
            position: absolute;
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7.23876 8.20102V3.74194C7.23876 3.33387 6.90489 3 6.49682 3C6.08875 3 5.75488 3.33387 5.75488 3.74194V8.20102H4.4268C4.09292 8.20102 3.9297 8.60167 4.16712 8.83167L6.23714 10.8943C6.38553 11.0352 6.61553 11.0352 6.76392 10.8943L8.83394 8.83167C9.07136 8.60167 8.90071 8.20102 8.57426 8.20102H7.23876Z" fill="%23333333"/></svg>');
          }
        }
      }

      &:hover {
        &.default {
          h4 {
            &::after {
              top: 2px;
              position: absolute;
              content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M5.04402 1.95617L3.41652 3.58367C3.22985 3.76451 3.35819 4.0795 3.62069 4.0795H4.66485V7.58534C4.66485 7.90617 4.92735 8.16867 5.24819 8.16867C5.56902 8.16867 5.83152 7.90617 5.83152 7.58534V4.0795H6.87569C7.13819 4.0795 7.26652 3.76451 7.07985 3.58367L5.45235 1.95617C5.34152 1.84534 5.15485 1.84534 5.04402 1.95617ZM9.33152 9.92451V6.41867C9.33152 6.09784 9.06902 5.83534 8.74819 5.83534C8.42735 5.83534 8.16485 6.09784 8.16485 6.41867V9.92451H7.12069C6.85819 9.92451 6.72985 10.2395 6.91652 10.4203L8.54402 12.042C8.66069 12.1528 8.84152 12.1528 8.95819 12.042L10.5857 10.4203C10.7724 10.2395 10.6382 9.92451 10.3815 9.92451H9.33152Z" fill="%23333333"/></svg>');
            }
          }
        }
      }
    }
  }

  &__count-title {
    min-width: 66px;
    flex: 1 1 auto;
    position: relative;

    &.asc {
      &::after {
        top: 2px;
        position: absolute;
        content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7.23876 5.79898V10.2581C7.23876 10.6661 6.90489 11 6.49682 11C6.08875 11 5.75488 10.6661 5.75488 10.2581V5.79898H4.4268C4.09292 5.79898 3.9297 5.39833 4.16712 5.16833L6.23714 3.10573C6.38553 2.96476 6.61553 2.96476 6.76392 3.10573L8.83394 5.16833C9.07136 5.39833 8.90071 5.79898 8.57426 5.79898H7.23876Z" fill="%23333333"/></svg>');
      }
    }
    &.desc {
      &::after {
        top: 2px;
        position: absolute;
        content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7.23876 8.20102V3.74194C7.23876 3.33387 6.90489 3 6.49682 3C6.08875 3 5.75488 3.33387 5.75488 3.74194V8.20102H4.4268C4.09292 8.20102 3.9297 8.60167 4.16712 8.83167L6.23714 10.8943C6.38553 11.0352 6.61553 11.0352 6.76392 10.8943L8.83394 8.83167C9.07136 8.60167 8.90071 8.20102 8.57426 8.20102H7.23876Z" fill="%23333333"/></svg>');
      }
    }

    &:hover {
      &.default {
        &::after {
          top: 2px;
          position: absolute;
          content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M5.04402 1.95617L3.41652 3.58367C3.22985 3.76451 3.35819 4.0795 3.62069 4.0795H4.66485V7.58534C4.66485 7.90617 4.92735 8.16867 5.24819 8.16867C5.56902 8.16867 5.83152 7.90617 5.83152 7.58534V4.0795H6.87569C7.13819 4.0795 7.26652 3.76451 7.07985 3.58367L5.45235 1.95617C5.34152 1.84534 5.15485 1.84534 5.04402 1.95617ZM9.33152 9.92451V6.41867C9.33152 6.09784 9.06902 5.83534 8.74819 5.83534C8.42735 5.83534 8.16485 6.09784 8.16485 6.41867V9.92451H7.12069C6.85819 9.92451 6.72985 10.2395 6.91652 10.4203L8.54402 12.042C8.66069 12.1528 8.84152 12.1528 8.95819 12.042L10.5857 10.4203C10.7724 10.2395 10.6382 9.92451 10.3815 9.92451H9.33152Z" fill="%23333333"/></svg>');
        }
      }
    }
  }

  // Count kutucukları (Count boxes)
  &__count {
    display: flex;
    width: 66px;
    height: 30px;
    gap: 4px;

    p {
      color: #333;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 14px !important;
      font-weight: 700 !important;
      line-height: 18px;
      margin-bottom: 0;
    }

    i {
      font-size: 16px !important;
    }
  }

  &__count-content {
    display: flex;
    gap: 2px;
    padding: 4px 8px;
    align-items: center;
    justify-content: center;
    border-radius: 64px;
    border: 0.5px solid #D4D4D4;
    background: #FAFAFA;
  }

  &__analyze-content {
    display: flex;
    gap: 2px;
    padding: 1px 8px;
    align-items: center;
    justify-content: center;
    border-radius: 512px;
    border: 1px solid #E5E5E5;
    background: #FAFAFA;

    p {
      color: #878787 !important;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 12px !important;
      font-weight: 500 !important;
      line-height: 16px !important;
      margin: 0;
    }
  }

  // Liste Öğesi (Item)
  &__item {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 16px 8px 16px 16px;
    background: #FFF;
    transition: all 0.3s ease-in-out;

    &:last-child {
      border-radius: 0 0 8px 8px;
    }

    &:hover {
      background: #FAFAFA;

      .interview-list__item-actions {
        display: flex !important;
      }
    }

    p {
      color: #333;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      margin-bottom: 0;
    }

    // Liste öğesi içindeki başlık alanı için (mobilde flex-direction değişikliği)
    .interview-list__column--title {
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      gap: 8px;
    }

    @media only screen and (max-width: 1150px) {
      position: relative;
    }
  }

  // Liste Öğesi içeriği
  &__item-content {
    display: flex;
    align-items: center;
    gap: var(--Padding-4XLarge, 48px);

    @media only screen and (max-width: 1150px) {
      flex-direction: column;
      align-items: flex-start;
      flex: 1;
      gap: 8px;
    }
  }

  // Liste Öğesi Eylem Butonu
  &__item-actions {
    display: none;
    width: 36px;
    height: 36px;
    padding: 10px 8px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 100%;
    border: 1px solid transparent;
    background: transparent;
    transition: all 0.3s ease-in-out;
    z-index: 1;

    &:hover,
    &:has(.show) {
      border: 1px solid var(--Stroke-Colors-Secondary-Gray-Stroke, #D4D4D4);
      background: var(--Background-Colors-Primary-Gray, #EEE);
    }

    i {
      font-size: 16px;
    }

    @media only screen and (max-width: 1150px) {
      display: flex;
    }
  }

  &__item-type {
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 2px;
    border-radius: 512px;
    border: 1px solid #E5E5E5;
    background: #FAFAFA;
    padding: 1px 8px;

    i {
      font-size: 14px;
      color: #878787;
    }

    p {
      color: #878787 !important;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
      margin: 0;
    }
  }

  // Durum bilgisi (Status) stilleri
  &__status {
    display: flex;
    padding: 1px 8px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border-radius: 512px;
    transition: all 0.5s ease-in-out;

    p {
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
    }

    i {
      font-size: 14px;
    }

    &.published {
      border: 1px solid #B6EAC9;
      background: #DBF4E4;

      p,
      i {
        color: #19552E !important;
      }
    }

    &.passive {
      border: 1px solid #E5E5E5;
      background: #FAFAFA;

      p,
      i {
        color: #878787 !important;
      }
    }
  }

  // Analyze alanı stilleri
  &__analyze {
    display: flex;
    align-items: center;
    gap: var(--Padding-XSmall, 2px);

    &.label-button {
      display: flex;
      padding: 1px 8px;
      justify-content: center;
      align-items: center;
      gap: 2px;
      border-radius: 512px;
      border: 1px solid #E5E5E5;
      background: #FAFAFA;
    }

    p {
      color: #878787;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      margin-bottom: 0;
    }

    i {
      color: #878787;
      font-size: 14px;
    }
  }
}

.empty-title {
  font-size: 22px;
  font-weight: 500;
  line-height: 28px;
  margin-bottom: 2rem;
}

.page-view {
  padding-top: 0 !important;
  background: #FAFAFA !important;
  .container {
    width: 100%;
    max-width: 100% !important;
    padding: 16px;
  }
}

.create-btn {
  border-radius: 40px !important;
  gap: 8px !important;
  transition: all 0.3s ease-in-out;

  i {
    font-weight: 900 !important;
    margin-right: 0 !important;
  }

  &:hover {
    background: #FF7415;
  }
}

.mobile-actions-area {
  position:sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #FFFFFF;
  padding: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #E5E5E5);

  .create-btn {
    width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
  }
}

#createNewInterviewBtnOne{
  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    width: 100%;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: 0px !important;
  }
}

.interview-list-filters-area {
  width: 100%;
  display: flex;
  margin-bottom: 16px;
  gap: 8px;
  align-items: center;

  @media only screen and (max-width: 1150px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    gap: 8px;
  }

  .search-area {
    display: flex;
    align-self: center;
    position: relative;
    width: fit-content;
    width: 240px;
    border-radius: 4px;
    border: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #E5E5E5);
    background: var(--Background-Colors-White, #FFF);
    height: 32px;

    @media only screen and (max-width: 1150px) {
      align-self: flex-start;
    }

    &:has(.search-area__input:focus) {
      border-color: #ff8d06 !important;
      box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.3) !important;
    }

    &__icon {
      position: absolute;
      width: 1.0625rem;
      height: 1.0625rem;
      right: 8px;
      top: 5px;
    }
    &__input {
      font-family: 'Roboto';
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.125rem;
      border: 0;
      padding: 8px;
      width: calc(100% - 16px);
      background: transparent;

      &:focus {
        outline: none;
      }
    }
  }
}

::v-deep {
  .multiselect {
    width: 135px;
    height: 32px;
    min-height: 32px;
    z-index: 999;
  }

  .status-multiselect,
  .type-multiselect {
    width: 94px !important;
    height: 32px;
    min-height: 32px;
    z-index: 999;
    .multiselect__content-wrapper {
      min-height: auto !important;
    }
  }
  .multiselect:not(.status-multiselect):not(.type-multiselect) {
    .multiselect__content-wrapper {
      min-height: auto !important;
    }
  }

  .multiselect--active {
    .multiselect__select {
      text-align: right;
      z-index: 1;
      transform: none;
      top: 0 !important;
    }

    .multiselect__placeholder {
      display: inline-block;
    }

    .multiselect__tags,
    .multiselect__single,
    .multiselect__placeholder {
      background: #EEE;
    }
  }

  .multiselect__select {
    height: 32px !important;
    min-height: 32px !important;
    padding: 6px 8px !important;
    top: 0;
    right: 0;
  }

  .multiselect__tags {
    height: 32px !important;
    min-height: 32px !important;
    padding: 6px 8px !important;
    border-radius: 40px;
    border: 1px solid #D4D4D4;
    background: #FFF;
    overflow: hidden;
    box-shadow: none;
    display: flex;
    align-items: center;

    &:has(.selected-option) {
      background: #EEE;

      .multiselect__single {
        background: #EEE;
      }
    }
  }

  .multiselect__single,
  .multiselect__placeholder {
    margin-bottom: 0;
    font-size: 12px !important;
    line-height: 18px;
    vertical-align: top;
  }

  .option__title {
    display: flex;
    align-items: center;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    color: #333 !important;

    span {
      padding: 0 4px;
    }

    i {
      color: #333;
      font-size: 20px;
    }
  }
  .multiselect__content {
    box-shadow: none !important;
  }

  .multiselect__content-wrapper {
    z-index: 999;
    top: 36px;
    padding: 4px 0;
    border-radius: 4px !important;
    border: 1px solid #E5E5E5;
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
  }

  .multiselect__option {
    padding: 6px 8px !important;
    height: 32px;
    min-height: auto;
    display: flex;
    align-items: center;
    font-family: Roboto;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 20px !important;
  }

  .multiselect__option--highlight {
    background: #EEE;
  }

  .multiselect__option--selected:after {
    display: none;
  }

  .multiselect__select:before {
    content:  url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M13.2292 7.49961L9.99583 10.7329L6.7625 7.49961C6.4375 7.17461 5.9125 7.17461 5.5875 7.49961C5.2625 7.82461 5.2625 8.34961 5.5875 8.67461L9.4125 12.4996C9.7375 12.8246 10.2625 12.8246 10.5875 12.4996L14.4125 8.67461C14.7375 8.34961 14.7375 7.82461 14.4125 7.49961C14.0875 7.18294 13.5542 7.17461 13.2292 7.49961Z" fill="%23333333"/></svg>') !important;
    border: none !important;
    top: 2% !important;
  }

  .multiselect__input {
    margin-bottom: 0px !important;
  }
}

::v-deep .new-modal {
  .modal-dialog {
    max-width: 372px;
  }
  .modal-content {
    border-radius: 12px;
  }

  .modal-header {
    border-bottom: 0;
    padding: 12px 12px 0px 12px;

    i {
      font-size: 24px;
      color: #333333;
    }
  }

  .modal-body {
    border-bottom: 0;
    padding: 0px 24px 24px 24px;

    img {
      margin-bottom: 14px;
    }

    h2 {
      color: #353535;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px;
      margin-bottom: 8px;
    }

    p {
      color: #858585;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 24px;
    }
  }

  .border-button-create {
    border: 1px solid #ff8d06;
    background: transparent !important;
    display: flex;
    padding: 9px 16px;
    height: auto;
    justify-content: center;
    align-items: center;
    border-radius: 40px;
    transition: all 0.2s ease-in-out;
    flex: 1;

    span {
      color: #ff8d06;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
      padding: 0 8px;
    }

    i {
      color: #ff8d06;
      font-size: 16px;
      margin-right: 0 !important;
    }

    &.disabled {
      border-color: transparent;
      cursor: auto !important;
    }

    &:hover {
      background: #ff8d06 !important;

      span,
      i {
        color: #fff;
      }
    }
  }

  .bg-button {
    display: flex;
    padding: 9px 16px;
    height: auto;
    justify-content: center;
    align-items: center;
    border-radius: 40px;
    border: 1px solid #ff8d06;
    background: #ff8d06;
    transition: all 0.2s ease-in-out;
    flex: 1;

    span {
      color: #fff;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
      padding: 0 8px;
    }

    i {
      color: #fff;
      font-size: 16px;
      margin-right: 0 !important;
    }

    &.disabled {
      border-color: transparent;
      cursor: auto !important;
      background:#EEE !important;

      span, i {
        color: #C3C3C3 !important;
      }
    }

    &:hover {
      background: #FF7415 !important;
    }
  }
}
</style>
